import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControlType,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { CrossBorderTradingModel } from './cross-border-trading.model';

export class CrossBorderTradingConfiguration extends ReportSectionConfigurationBase {
  typeName = 'CrossBorderTradingConfiguration';
  nodataLocalizationKeyName = 'bnyCrossBorderTrading';
  readonly reportSection = ReportSection.CrossBorderTrading;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_CrossBorderTrading];
  minSize = 3;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'date',
      displayName: 'Date',
      isSelected: true,
      canConfigure: false,
      property: 'date',
      isStatic: true,
      type: ReportSectionConfigurationControlType.Date
    },
    {
      name: 'drsIssued',
      displayName: 'DRs Issued',
      isSelected: true,
      canConfigure: true,
      property: 'drsIssued',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'drsCancelled',
      displayName: 'DRs Canceled',
      isSelected: true,
      canConfigure: true,
      property: 'drsCancelled',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'netDrsIssuedCancelled',
      displayName: 'Net DRs Issued/Cancelled',
      isSelected: true,
      canConfigure: true,
      property: 'netDrsIssuedCancelled',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'drsOutstanding',
      displayName: 'DRs Outstanding',
      isSelected: true,
      canConfigure: true,
      property: 'drsOutstanding',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'closePrice',
      displayName: 'DRs Close Price, USD',
      isSelected: true,
      canConfigure: true,
      property: 'closePrice',
      type: ReportSectionConfigurationControlType.Decimal
    }
  ];

  get name(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'dailyDRCrossBorderTrading';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'Daily DR Cross Border Trading';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface CrossBorderTradingData {
  [ReportViewModelSection.BnyManagementReport_CrossBorderTrading]: CrossBorderTradingModel;
}
